import useSWR from "swr";
import axios from "axios";

function useDesignAndEngineeringTotalQuotedChart({ startDate, endDate }) {
  return useSWR([
    `${process.env.REACT_APP_API_URL}/design-and-engineering-charts/total-quoted`, startDate, endDate], async ([url, startDate, endDate]) => {
      const params = new URLSearchParams();

      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);

      const { data: { chartData, totalMargin } } = await axios.get(`${url}?${params.toString()}`);

      return { chartData, totalMargin };
    });
}

export default useDesignAndEngineeringTotalQuotedChart;
